export type CompaniesInstallmentsData = {
  companyId: string | null
  maxInstallments: number
  hasInterest: boolean
}

export const COMPANIES_INSTALLMENTS_DATA: CompaniesInstallmentsData[] = [
  {
    companyId: '',
    maxInstallments: 12,
    hasInterest: true,
  },
  {
    companyId: '1',
    maxInstallments: 12,
    hasInterest: true,
  },
  {
    companyId: '2',
    maxInstallments: 21,
    hasInterest: true,
  },
  {
    companyId: '3',
    maxInstallments: 12,
    hasInterest: false,
  },
]
